"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUB_STAGES = exports.STAGE_HIERARCHY = exports.MainStageType = void 0;
var MainStageType;
(function (MainStageType) {
    MainStageType["NEW"] = "new";
    MainStageType["FOLLOW_UP"] = "follow_up";
    MainStageType["WAITING_FOR_REPORT"] = "waiting_for_report";
    MainStageType["QUOTE"] = "quote";
    MainStageType["SPECIAL_CASES"] = "special_cases";
    MainStageType["NOT_INTERESTED"] = "not_interested";
    MainStageType["ALL"] = "ALL";
})(MainStageType || (exports.MainStageType = MainStageType = {}));
// Group the stages into a logical hierarchy
exports.STAGE_HIERARCHY = [
    {
        id: MainStageType.NEW,
        name: 'חדש',
        order: 1,
        subStages: [
            {
                id: 'new_lead',
                name: 'ליד חדש',
                mainStageId: MainStageType.NEW,
                order: 2,
            },
        ],
    },
    {
        id: MainStageType.FOLLOW_UP,
        name: 'מעקב',
        order: 2,
        subStages: [
            {
                id: 'no_answer_1',
                name: 'לא עונה 1',
                mainStageId: MainStageType.FOLLOW_UP,
                order: 1,
            },
            {
                id: 'no_answer_2',
                name: 'לא עונה 2',
                mainStageId: MainStageType.FOLLOW_UP,
                order: 2,
            },
            {
                id: 'evening',
                name: 'ערב',
                mainStageId: MainStageType.FOLLOW_UP,
                order: 4,
            },
            {
                id: 'morning',
                name: 'בוקר',
                mainStageId: MainStageType.FOLLOW_UP,
                order: 5,
            },
            {
                id: 'callback_sunday',
                name: 'ראשון/חגים',
                mainStageId: MainStageType.FOLLOW_UP,
                order: 6,
            },
            {
                id: 'afternoon',
                name: 'צהריים',
                mainStageId: MainStageType.FOLLOW_UP,
                order: 7,
            },
            {
                id: 'record_details',
                name: 'רשמו פרטים',
                mainStageId: MainStageType.FOLLOW_UP,
                order: 11,
            },
            {
                id: 'inspection_scheduled',
                name: 'קביעת בדיקה',
                mainStageId: MainStageType.FOLLOW_UP,
                order: 12,
            },
        ],
    },
    {
        id: MainStageType.QUOTE,
        name: 'הצעות מחיר',
        order: 3,
        subStages: [
            {
                id: 'quote_1400',
                name: '1400',
                mainStageId: MainStageType.QUOTE,
                order: 1,
            },
            {
                id: 'quote_1650',
                name: '1650',
                mainStageId: MainStageType.QUOTE,
                order: 2,
            },
            {
                id: 'quote_1750',
                name: '1750',
                mainStageId: MainStageType.QUOTE,
                order: 3,
            },
            {
                id: 'quote_1800',
                name: '1800',
                mainStageId: MainStageType.QUOTE,
                order: 4,
            },
            {
                id: 'quote_1900_lab',
                name: '1900+מעבדה',
                mainStageId: MainStageType.QUOTE,
                order: 5,
            },
            {
                id: 'quote_2200',
                name: '2200',
                mainStageId: MainStageType.QUOTE,
                order: 6,
            },
            {
                id: 'old_quotes',
                name: 'כל הצעות מחיר ישנים 1400-1600',
                mainStageId: MainStageType.QUOTE,
                order: 7,
            },
        ],
    },
    {
        id: MainStageType.SPECIAL_CASES,
        name: 'מיוחדים',
        order: 4,
        subStages: [
            {
                id: 'renovation',
                name: 'מעוניין בשיפוץ',
                mainStageId: MainStageType.SPECIAL_CASES,
                order: 1,
            },
            {
                id: 'lead_to_contractor',
                name: 'הועבר לקבלן',
                mainStageId: MainStageType.SPECIAL_CASES,
                order: 2,
            },
            {
                id: 'contractor_wants_work',
                name: 'קבלן מעוניין לעבוד',
                mainStageId: MainStageType.SPECIAL_CASES,
                order: 3,
            },
            {
                id: 'winter_leak',
                name: 'בדיקות מעבדה',
                mainStageId: MainStageType.SPECIAL_CASES,
                order: 4,
            },
            {
                id: 'special_igor',
                name: 'איגור מיוחדים',
                mainStageId: MainStageType.SPECIAL_CASES,
                order: 5,
            },
            {
                id: 'special_costa',
                name: 'קוסטה מיוחדים',
                mainStageId: MainStageType.SPECIAL_CASES,
                order: 6,
            },
            {
                id: 'interested',
                name: 'מעוניין',
                mainStageId: MainStageType.SPECIAL_CASES,
                order: 7,
            },
            {
                id: 'ai_retivut',
                name: 'AI רטיבות',
                mainStageId: MainStageType.SPECIAL_CASES,
                order: 8,
            },
        ],
    },
    {
        id: MainStageType.WAITING_FOR_REPORT,
        name: 'ממתין לדוח',
        order: 5,
        subStages: [],
    },
    {
        id: MainStageType.NOT_INTERESTED,
        name: 'לא מעוניין',
        order: 6,
        subStages: [
            {
                id: 'closed_with_other_company',
                name: 'סגר עם חברה אחרת',
                mainStageId: MainStageType.NOT_INTERESTED,
                order: 1,
            },
            {
                id: 'just_inquired',
                name: 'רק בירר',
                mainStageId: MainStageType.NOT_INTERESTED,
                order: 2,
            },
            {
                id: 'waiting_owner_approval',
                name: 'ממתין לאישור מבעל דירה',
                mainStageId: MainStageType.NOT_INTERESTED,
                order: 3,
            },
            {
                id: 'not_relevant_no_inspection',
                name: 'לא רלוונטי / לא צריך בדיקה',
                mainStageId: MainStageType.NOT_INTERESTED,
                order: 4,
            },
            {
                id: 'not_interested_expensive',
                name: 'יקר',
                mainStageId: MainStageType.NOT_INTERESTED,
                order: 5,
            },
            {
                id: 'not_interested_repair',
                name: 'תיקן',
                mainStageId: MainStageType.NOT_INTERESTED,
                order: 6,
            },
            {
                id: 'not_interested_other',
                name: 'רחוק צפון/דרום',
                mainStageId: MainStageType.NOT_INTERESTED,
                order: 7,
            },
            {
                id: 'not_interested_insurance',
                name: 'ביטוח',
                mainStageId: MainStageType.NOT_INTERESTED,
                order: 8,
            },
            {
                id: 'not_interested_no_response',
                name: 'לקוח לא עונה מספר פעמים',
                mainStageId: MainStageType.NOT_INTERESTED,
                order: 9,
            },
            {
                id: 'not_interested_ad_company',
                name: 'חברת פרסום',
                mainStageId: MainStageType.NOT_INTERESTED,
                order: 10,
            },
            {
                id: 'not_interested_wrong_details',
                name: 'פרטים לא נכונים',
                mainStageId: MainStageType.NOT_INTERESTED,
                order: 11,
            },
        ],
    },
];
// Flattened array of all substages for easier lookup
exports.SUB_STAGES = exports.STAGE_HIERARCHY.reduce((acc, mainStage) => [...acc, ...mainStage.subStages], []);
